import { render, staticRenderFns } from "./addressForm.vue?vue&type=template&id=5d342a1c"
import script from "./addressForm.vue?vue&type=script&lang=js"
export * from "./addressForm.vue?vue&type=script&lang=js"
import style0 from "./addressForm.vue?vue&type=style&index=0&id=5d342a1c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports